import { isEmpty } from 'lodash';
import { useCallback, useContext, useState } from 'react';
import { AnchoredSheet } from '@shared/components/AnchoredSheet';
import { MBButton } from '@shared/components/MBButton';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBAutosizeTextInput } from '@shared/components/textInput';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext, grid } from '@shared/styles';
import { Trigger, useBoolean, useExecuteOnTrigger } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { WorkflowComponentStyles } from './WorkflowComponentStyles';

interface Props {
  answerTrigger: Trigger;
  label: string;
  value: string;
  anchorName: string;
  onChange(newValue: string): void;
  isReadOnly?: boolean;
}

/** @deprecated Use AuditTextEditField instead. */
export function WorkflowAuditTextarea({
  answerTrigger,
  label,
  value,
  anchorName,
  onChange,
  isReadOnly,
}: Props) {
  const colors = useContext(ColorThemeContext);
  const [sheetVisible, showSheet, hideSheet] = useBoolean(false);
  const [localValue, setLocalValue] = useState(value);
  const onOk = useCallback(() => {
    onChange(localValue);
    hideSheet();
  }, [localValue, onChange, hideSheet]);
  useExecuteOnTrigger(answerTrigger, showSheet);

  return (
    <>
      <View paddingBottom={2}>
        <MBTextBody1 flex>{label}</MBTextBody1>
      </View>
      {!isEmpty(value) && (
        <MBTouchableOpacity disabled={isReadOnly} onPress={showSheet}>
          <MBView
            style={WorkflowComponentStyles.textarea}
            paddingVertical={2}
            paddingHorizontal={1}
          >
            <MBTextBody1>{value}</MBTextBody1>
          </MBView>
        </MBTouchableOpacity>
      )}
      {sheetVisible && (
        <AnchoredSheet
          initialSize="half"
          onClose={hideSheet}
          title={i18n('card.blocks.question.answerButtonLabel')}
          anchorName={anchorName}
          style={{ minWidth: grid(40) }}
        >
          <View padding={2}>
            <MBAutosizeTextInput
              style={{ backgroundColor: colors.backgroundInactive, borderRadius: grid(1) }}
              onChangeText={setLocalValue}
              initialValue={value}
              placeholder={i18n('card.blocks.question.answerPlaceholder')}
              autoFocus
              padding="normal"
            />
            <View paddingBottom={2} />
            <MBButton title={i18n('common.ok')} onPress={onOk} />
          </View>
        </AnchoredSheet>
      )}
    </>
  );
}
